import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: "POST" },
    autoDismissAfter: { type: Number, default: 0 }
  }

  connect() {
    if (this.autoDismissAfterValue > 0) {
      this.element.style.transition = "opacity 400ms ease"
      this.autoTimer = setTimeout(() => this.fade(), this.autoDismissAfterValue)
    }
  }

  disconnect() {
    if (this.autoTimer) clearTimeout(this.autoTimer)
  }

  fade() {
    this.element.style.opacity = "0"
    setTimeout(() => { this.element.style.display = "none" }, 400)
  }

  dismiss() {
    this.element.style.display = "none"

    if (this.urlValue) {
      fetch(this.urlValue, {
        method: this.methodValue,
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
          "Content-Type": "application/json"
        }
      })
    }
  }
}
